import type { SearchEntityType, SearchQueryRequest } from '@/entities/search';
import type { SearchQueryParams } from './types';

/**
 * Builds SearchQueryParams from committed search (for useCommittedSearch pattern).
 */
export const buildSearchQueryParams = (
  committed: {
    query: string;
    mode: SearchQueryParams['searchMode'];
  } | null,
): SearchQueryParams => {
  if (!committed) {
    return { human: '', dsl: '', searchMode: 'nl' };
  }
  return {
    human: committed.mode === 'nl' ? committed.query : '',
    dsl: committed.mode === 'dsl' ? committed.query : '',
    searchMode: committed.mode,
  };
};

/**
 * Формирует базовые поля запроса (entityType, query), общие для всех типов сущностей.
 * Сортировка обрабатывается отдельно для каждого типа сущности.
 */
export const buildBaseRequest = (
  entityType: SearchEntityType,
  query: SearchQueryParams,
): Pick<SearchQueryRequest, 'entityType' | 'dslHuman' | 'dsl'> => {
  const currentQuery = query.searchMode === 'nl' ? query.human : query.dsl;
  const trimmedQuery = currentQuery.trim();

  const base: Pick<SearchQueryRequest, 'entityType' | 'dslHuman' | 'dsl'> = {
    entityType,
  };

  if (trimmedQuery) {
    if (query.searchMode === 'nl') {
      base.dslHuman = trimmedQuery;
    } else {
      base.dsl = trimmedQuery;
    }
  }

  return base;
};
